<template lang="pug">
.idelModel
  Icon(type="md-arrow-dropup",@click="$emit('upData')")
  Icon(type="md-arrow-dropdown",@click="$emit('downData')")
  Poptip(v-if="isDep" confirm title="确定删除该条数据?此操作不可恢复" @on-ok="ok")
    Icon(:disabled="true" type="ios-trash")
  Icon(v-else type="ios-trash" @click='delModel')
</template>

<script>
export default {
  props: {
    delModel: {
      type: Function,
      required: true
    },
    isDep: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isNewCom() {
      return sessionStorage.getItem("isDisabled") === "true";
    }
  },
  methods: {
    ok() {
      if (this.isNewCom) {
        this.$Message.warning("不可删除！");
      } else {
        this.$emit("handleDel");
      }
    }
    //
  }
};
</script>

<style lang="stylus">
.idelModel
  position absolute
  top 6px
  right 0
  .ivu-icon
    color #3A76D2FF
    font-size 22px
    top 0
    margin-right 12px
    background #F2F5FAFF
    width 24px
    height 24px
    border-radius 4px
    text-align center
    line-height @height
    &:hover
      cursor pointer
</style>
